import React from "react";
import "../componnetsCss/Contact.css"
import { Button, Container, Nav, Navbar } from "react-bootstrap";
import { FaPhoneAlt , FaHeadset , FaWhatsapp, FaShieldAlt, FaClock } from "react-icons/fa";
import { Link } from "react-router-dom";
import {
  Route,
  RouterProvider,
  Routes,
  createBrowserRouter,
} from "react-router-dom";
import Withdrewl from "./Withdrewl";

const ContactUs = () => {
  return (
    <div className="support-page-wrapper">
  <div className="support-container">
    <div className="support-glass-card">
      <div className="support-icon-circle">
        <FaHeadset className="headset-icon" />
      </div>
      
      <h1 className="support-title">Help & Support</h1>
      <p className="support-subtitle">
        Having trouble? Our team is available 24/7 to assist you with your investments and withdrawals.
      </p>

      <div className="support-action-area">
        <a 
          href="https://wa.me/923287614001" 
          className="whatsapp-contact-btn"
          target="_blank" 
          rel="noopener noreferrer"
        >
          <FaWhatsapp className="btn-icon-ws" />
          Chat on WhatsApp
        </a>
      </div>

      <div className="support-footer-info">
        <span><FaShieldAlt /> Secure Support</span>
        <span className="dot-separator">•</span>
        <span><FaClock /> Avg. Response: 5 Mins</span>
      </div>
    </div>
  </div>
</div>
  );
};

export default ContactUs;
